import { render, staticRenderFns } from "./detailConcepts.vue?vue&type=template&id=229dca6a&scoped=true&"
import script from "./detailConcepts.vue?vue&type=script&lang=js&"
export * from "./detailConcepts.vue?vue&type=script&lang=js&"
import style0 from "./detailConcepts.vue?vue&type=style&index=0&id=229dca6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229dca6a",
  null
  
)

export default component.exports